export const AGENTS = 'agents';
export const CLOUD_AGENTS = 'cloud agents';
export const RUN_STATUS_LOG = 'run status log';
